import { useContext, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import routes from "@/routers/routes";
import { Form } from "@/ui/form";
import { loginSchema, LoginSchema } from "@/validators/login.schema";
import { SubmitHandler } from "react-hook-form";
import { PiArrowRightBold } from "react-icons/pi";
import { Button, Input, Password } from "rizzui";
import { login } from "@/server/api-services";
import { AuthContext } from "@/auth/authContext";
import { setSession } from "../../auth/utils";
import { UserSession } from "@/types";

export default function SignInForm() {
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = useState(false);

    const [error, setError] = useState("");

    const { setAuthenticated } = useContext(AuthContext);

    const [reset, setReset] = useState({});

    const onSubmit: SubmitHandler<LoginSchema> = async (data) => {
        try {
            setIsLoading(true);
            const response = await login(data.email, data.password);
            if (response.statusCode === 200) {
                const userSession = response.data as UserSession;

                console.log(response);

                setAuthenticated(true);
                setSession(userSession.token);

                navigate(routes.orders.dashboard);
            }

            console.log("Returned response", response);
        } catch (error) {
            setError((error as any)?.message);
        }
        setIsLoading(false);
    };

    return (
        <>
            {error && (
                <div className="p-4 mb-4 text-red-500 bg-red-100 rounded-md ">
                    {error}
                </div>
            )}
            <Form<LoginSchema>
                validationSchema={loginSchema}
                resetValues={reset}
                onSubmit={onSubmit}
                useFormProps={{
                    defaultValues: {
                        email: "",
                        password: "",
                    },
                }}
            >
                {({ register, formState: { errors } }) => (
                    <div className="space-y-5">
                        <Input
                            type="email"
                            size="lg"
                            label="Email"
                            placeholder="Enter your email"
                            className="[&>label>span]:font-medium"
                            inputClassName="text-sm"
                            {...register("email")}
                            error={errors.email?.message}
                        />
                        <Password
                            label="Password"
                            placeholder="Enter your password"
                            size="lg"
                            className="[&>label>span]:font-medium"
                            inputClassName="text-sm"
                            {...register("password")}
                            error={errors.password?.message}
                        />
                        <div className="flex flex-row justify-content-end pb-2">
                            <Link
                                to={routes.auth.forgotPassword1}
                                className="h-auto p-0 text-sm font-semibold text-blue underline transition-colors hover:text-gray-900 hover:no-underline"
                            >
                                Forget Password?
                            </Link>
                        </div>
                        <Button
                            className="w-full"
                            type="submit"
                            size="lg"
                            isLoading={isLoading}
                        >
                            <span>Sign in</span>{" "}
                            <PiArrowRightBold className="ms-2 mt-0.5 h-5 w-5" />
                        </Button>
                    </div>
                )}
            </Form>
        </>
    );
}
